import React from 'react';
import { Link } from 'react-router-dom';
import { toCompanySlug } from '../data/meetings';

export default function SponsorCard({ name, logo }) {
  const slug = toCompanySlug(name);
  return (
    <Link className="portal-sponsor-card" to={`./${slug}`}>
      {logo && (
        <div className="portal-sponsor-logo">
          <img src={logo} alt={`${name} logo`} />
        </div>
      )}
      <div className="portal-sponsor-name">{name}</div>
    </Link>
  );
}
